import React, { useState, useEffect } from 'react';
import './OpportunitesPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import opportuniteService from '../services/opportuniteService';
import { getImageUrl, handleImageError } from '../utils/imageUtils';
import { toSentenceCase } from '../utils/textUtils';
import useSEO from '../hooks/useSEO';

function OpportunitesPage() {
  useSEO({
    title: "Opportunités, Stages & Bourses d'Études | Insertion & Carrière",
    description: "Découvrez les opportunités de stages professionnels, bourses d'études et partenariats entreprises pour les élèves et étudiants du GSU Les Palmiers.",
    keywords: "stages Bénin, bourses études Abomey-Calavi, opportunités élèves GSU Palmiers, stages entreprises Togba, insertion professionnelle Bénin",
    canonicalUrl: "https://gsulespalmiers.bj/opportunites"
  });

  const [activeTab, setActiveTab] = useState('bourse');
  const [opportunites, setOpportunites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOpportunites();
  }, [activeTab]);

  const loadOpportunites = async () => {
    try {
      setLoading(true);
      const response = await opportuniteService.getAll({ type: activeTab });
      setOpportunites(response.data.data || response.data);
    } catch (error) {
      console.error('Erreur lors du chargement des opportunités:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (slug) => {
    if (window.navigateTo) {
      window.navigateTo('opportunite-detail', slug);
    }
  };

  return (
    <div className="opportunites-page">
      <Header activePage="opportunites" />
      
      <div className="opportunites-hero">
        <div className="container">
          <h1>Opportunités</h1>
          <p>Découvrez nos offres de stages et bourses d'études</p>
        </div>
      </div>

      <div className="opportunites-tabs">
        <div className="container">
          <div className="tabs-wrapper">
            <button 
              className={`tab-btn ${activeTab === 'bourse' ? 'active' : ''}`}
              onClick={() => setActiveTab('bourse')}
            >
              Bourses d'études
            </button>
            <button 
              className={`tab-btn ${activeTab === 'stage' ? 'active' : ''}`}
              onClick={() => setActiveTab('stage')}
            >
              Offres de Stages
            </button>
          </div>
        </div>
      </div>

      <div className="opportunites-content">
        <div className="container">
          {loading ? (
            <div className="loading">Chargement...</div>
          ) : opportunites.length === 0 ? (
            <div className="no-data">
              <p>Aucune {activeTab === 'bourse' ? 'bourse' : 'offre de stage'} disponible pour le moment.</p>
            </div>
          ) : (
            <div className="opportunites-grid">
              {opportunites.map((opp) => (
                <div key={opp.id} className="opportunite-card">
                  {opp.image && (
                    <div className="opportunite-image">
                      <img 
                        src={getImageUrl(opp.image, '/images/logo.svg')} 
                        alt={opp.titre}
                        onError={(e) => handleImageError(e, '/images/logo.svg')}
                      />
                      <span className="opportunite-type">{opp.type === 'bourse' ? 'Bourse' : 'Stage'}</span>
                    </div>
                  )}
                  <div className="opportunite-body">
                    <h3>{toSentenceCase(opp.titre)}</h3>
                    <div className="opportunite-meta">
                      <span className="organisme">{toSentenceCase(opp.organisme)}</span>
                      <span className="location">{opp.ville ? `${toSentenceCase(opp.ville)}, ` : ''}{toSentenceCase(opp.pays)}</span>
                    </div>
                    <p className="opportunite-description">{toSentenceCase(opp.description)}</p>
                    <div className="opportunite-footer">
                      <span className="date-limite">
                        Date limite: {new Date(opp.date_limite).toLocaleDateString('fr-FR')}
                      </span>
                      <button 
                        className="btn-details"
                        onClick={() => handleViewDetails(opp.slug)}
                      >
                        Voir détails
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      
      <Footer />
    </div>
  );
}

export default OpportunitesPage;
